import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { Profile } from 'src/app/models/profile';
import { AlertService } from 'src/app/services/alert/alert.service';
import { AccountService } from 'src/app/services/auth/account.service';

@Component({
  selector: 'swg-header',
  templateUrl: './swg-header.component.html',
  styleUrls: ['./swg-header.component.scss'],
})
export class SwgHeaderComponent {
  @Input() title: string;
  @Input() path: string;
  @Input() profileType: string;
  @Input() profile: Profile;

  constructor(
    private alert: AlertService,
    private router: Router,
    private account: AccountService,
    private storage: Storage,
    private platform: Platform,
  ) {
  }

  get isCordova() {
    return this.platform.is('cordova');
  }

  async logout() {
    await this.alert.confirm({
      messageKey: 'LOGOUT_MESSAGE',
      okHandler: async () => {
        this.resetProfileOnIonicStorage();
        this.removeProfileTypePreferences();
        await this.storage.remove('lastUserSearch');  
        
        await this.account.logout(); // TIP set redirect from web browser
        if (this.isCordova) {
          this.router.navigate(['/'], { replaceUrl: true }); // TIP set redirect from app
        }
      }
    });
  }

  async resetProfileOnIonicStorage() {
    await this.storage.remove('onboardingFormSlideOne');
    await this.storage.remove('onboardingFormSlideTwo');
  }

  async removeProfileTypePreferences() {
    await this.storage.remove('profileType');
  }
}
